import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { types } from 'types/passengers';
import { StyledAgesContainer, StyledFlexAges, StyledTitle, StyledSubtitle } from '../BookingMagnet.styles';
import Select from 'components/ui/Select';

const dataPerPaxType = {
  [types.YOUTH]: {
    name: 'youths',
    defaultAge: '12',
    agesRange: ['12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25'],
    stateAge: `youthAges`,
    messageId: `youthAge`
  },
  [types.CHILD]: {
    name: 'children',
    defaultAge: '0',
    agesRange: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11'],
    stateAge: `childAges`,
    messageId: `childrenAge`
  }
};

const DBAgesModal = ({ paxsByType = 0, type = types.YOUTH, ages = [], setState = () => {} }) => {
  const { name, agesRange, defaultAge, stateAge, messageId } = dataPerPaxType[type];
  const defaultPaxs = new Array(paxsByType).fill(defaultAge);

  useEffect(() => {
    setState({
      [stateAge]: defaultPaxs.map((_, index) => ({ name: 1 + index, value: defaultAge }))
    });
  }, []);

  return (
    <StyledAgesContainer>
      <StyledTitle data-testid={`bookingDetails.numberOf.${name}`}>
        {paxsByType} <FormattedMessage id={`bookingDetails.numberOf.${name}`} />
      </StyledTitle>
      {defaultPaxs.map((_, index) => (
        <StyledFlexAges key={`age-container--${index}`}>
          <StyledSubtitle data-testid={`bookingDetails.${messageId}`}>
            <FormattedMessage id={`bookingDetails.${messageId}`} /> {1 + index}:{' '}
          </StyledSubtitle>
          <Select
            defaultValue={defaultAge}
            name={`${name}--${1 + index}`}
            data-testid={`${name}--${1 + index}`}
            onChange={(event) => {
              ages[index].value = event.target.value;
              setState({ [stateAge]: ages });
            }}
          >
            {agesRange.map((i, indexTwo) => (
              <option key={`${name}--${1 + index}--age--${i}--${indexTwo}`} value={i}>
                {i}
              </option>
            ))}
          </Select>
        </StyledFlexAges>
      ))}
    </StyledAgesContainer>
  );
};

DBAgesModal.propTypes = {
  paxsByType: PropTypes.number,
  type: PropTypes.oneOf(['YTH', 'CH']),
  ages: PropTypes.arrayOf(PropTypes.string),
  setState: PropTypes.func
};

export default DBAgesModal;
